'use client'

import { RemoveCardDialogContent } from '~/components/cards/RemoveCardDialogContent'
import { useAuth } from '~/context/AuthProvider'
import { Card } from '~/types/cards'

// Opens the remove-card confirmation dialog. Shared by the cards table row
// actions and the card detail page.
export const useRemoveCardDialog = () => {
  const { setGlobalModalState, closeGlobalModal } = useAuth()

  return (card: Card) =>
    setGlobalModalState({
      isOpen: true,
      content: (
        <RemoveCardDialogContent card={card} closeDialog={closeGlobalModal} />
      ),
    })
}
